export const patients = [
  {
    id: 1,
    lastName: "Smith",
    firstName: "John",
    middleName: null,
    dateOfBirth: "09/09/1983",
    medicalRecordNumber: null,
    accountNumber: "56746578",
    phone: "303-555-0101",
    ssn: "900-11-1037",
    address: "107 Oak Ave, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 2,
    lastName: "Smith",
    firstName: "John",
    middleName: null,
    dateOfBirth: "09/18/1968",
    medicalRecordNumber: null,
    accountNumber: "82736451",
    phone: "303-555-0102",
    ssn: "900-12-1074",
    address: "114 Pine Rd, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 3,
    lastName: "Smith",
    firstName: "John",
    middleName: "Gilbert",
    dateOfBirth: "03/05/1985",
    medicalRecordNumber: null,
    accountNumber: null,
    phone: "303-555-0103",
    ssn: "900-13-1111",
    address: "121 Cedar Ln, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 4,
    lastName: "Smith",
    firstName: "John",
    middleName: "Franklin",
    dateOfBirth: "01/30/1989",
    medicalRecordNumber: "4567890",
    accountNumber: null,
    phone: "303-555-0104",
    ssn: "900-14-1148",
    address: "128 Elm Dr, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 5,
    lastName: "Smith",
    firstName: "John",
    middleName: null,
    dateOfBirth: "06/20/1977",
    medicalRecordNumber: "0123456",
    accountNumber: null,
    phone: "303-555-0105",
    ssn: "900-15-1185",
    address: "135 Birch Ct, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 6,
    lastName: "Smith",
    firstName: "John",
    middleName: null,
    dateOfBirth: "05/12/1970",
    medicalRecordNumber: "8901234",
    accountNumber: null,
    phone: "303-555-0106",
    ssn: "900-16-1222",
    address: "142 Walnut Blvd, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 7,
    lastName: "Smith",
    firstName: "John",
    middleName: "Theodore",
    dateOfBirth: "04/23/1988",
    medicalRecordNumber: "9876543",
    accountNumber: "74651283",
    phone: "303-555-0107",
    ssn: "900-17-1259",
    address: "149 Spruce Way, Denver, CO",
    facility: "East Emergency",
    application: "Centricity with ROI",
  },
  {
    id: 8,
    lastName: "Smith",
    firstName: "John",
    middleName: "Eugene",
    dateOfBirth: "07/15/1962",
    medicalRecordNumber: "7654321",
    accountNumber: "46512837",
    phone: "303-555-0108",
    ssn: "900-18-1296",
    address: "156 Maple St, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 9,
    lastName: "Smith",
    firstName: "John",
    middleName: "Cecil",
    dateOfBirth: "08/07/1982",
    medicalRecordNumber: "7890123",
    accountNumber: "65128374",
    phone: "303-555-0109",
    ssn: "900-19-1333",
    address: "163 Oak Ave, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 10,
    lastName: "SMART",
    firstName: "WILMA",
    middleName: "Louise",
    dateOfBirth: "11/02/1975",
    medicalRecordNumber: "5544332",
    accountNumber: "99887766",
    phone: "303-555-0110",
    ssn: "900-20-1370",
    address: "170 Pine Rd, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 11,
    lastName: "Cadence",
    firstName: "Anna",
    middleName: "Marie",
    dateOfBirth: "12/10/1995",
    medicalRecordNumber: "9988776",
    accountNumber: "55443322",
    phone: "303-555-0111",
    ssn: "900-21-1407",
    address: "177 Cedar Ln, Denver, CO",
    facility: "West Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 113,
    lastName: "Johnson",
    firstName: "Michael",
    middleName: "Ray",
    dateOfBirth: "02/14/1972",
    medicalRecordNumber: "3456789",
    accountNumber: "34561234",
    phone: "303-555-0112",
    ssn: "900-22-1444",
    address: "184 Elm Dr, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 12,
    lastName: "Brown",
    firstName: "David",
    middleName: null,
    dateOfBirth: "10/01/1981",
    medicalRecordNumber: null,
    accountNumber: "76234519",
    phone: "303-555-0113",
    ssn: "900-23-1481",
    address: "191 Birch Ct, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 13,
    lastName: "Taylor",
    firstName: "Robert",
    middleName: "Allen",
    dateOfBirth: "12/11/1965",
    medicalRecordNumber: "9123456",
    accountNumber: null,
    phone: "303-555-0114",
    ssn: "900-24-1518",
    address: "198 Walnut Blvd, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 14,
    lastName: "Anderson",
    firstName: "James",
    middleName: "Scott",
    dateOfBirth: "08/30/1990",
    medicalRecordNumber: "1234567",
    accountNumber: "87342198",
    phone: "303-555-0115",
    ssn: "900-25-1555",
    address: "205 Spruce Way, Denver, CO",
    facility: "East Emergency",
    application: "Centricity with ROI",
  },
  {
    id: 15,
    lastName: "Clark",
    firstName: "Daniel",
    middleName: null,
    dateOfBirth: "06/17/1978",
    medicalRecordNumber: "3344556",
    accountNumber: null,
    phone: "303-555-0116",
    ssn: "900-26-1592",
    address: "212 Maple St, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 16,
    lastName: "Wilson",
    firstName: "Thomas",
    middleName: "Lee",
    dateOfBirth: "03/22/1974",
    medicalRecordNumber: "7788991",
    accountNumber: "44556677",
    phone: "303-555-0117",
    ssn: "900-27-1629",
    address: "219 Oak Ave, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 17,
    lastName: "Moore",
    firstName: "Christopher",
    middleName: null,
    dateOfBirth: "11/19/1986",
    medicalRecordNumber: null,
    accountNumber: "55667788",
    phone: "303-555-0118",
    ssn: "900-28-1666",
    address: "226 Pine Rd, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 18,
    lastName: "Jackson",
    firstName: "Anthony",
    middleName: "Paul",
    dateOfBirth: "07/04/1979",
    medicalRecordNumber: "6677889",
    accountNumber: null,
    phone: "303-555-0119",
    ssn: "900-29-1703",
    address: "233 Cedar Ln, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 19,
    lastName: "White",
    firstName: "Mark",
    middleName: null,
    dateOfBirth: "01/15/1969",
    medicalRecordNumber: "8899001",
    accountNumber: "66778899",
    phone: "303-555-0120",
    ssn: "900-30-1740",
    address: "240 Elm Dr, Denver, CO",
    facility: "East Emergency",
    application: "Centricity with ROI",
  },
  {
    id: 20,
    lastName: "Harris",
    firstName: "Steven",
    middleName: "Clark",
    dateOfBirth: "09/27/1984",
    medicalRecordNumber: "9900112",
    accountNumber: null,
    phone: "303-555-0121",
    ssn: "900-31-1777",
    address: "247 Birch Ct, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 21,
    lastName: "Martin",
    firstName: "Andrew",
    middleName: null,
    dateOfBirth: "05/09/1971",
    medicalRecordNumber: "1122334",
    accountNumber: "77889900",
    phone: "303-555-0122",
    ssn: "900-32-1814",
    address: "254 Walnut Blvd, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 22,
    lastName: "Thompson",
    firstName: "Joshua",
    middleName: "Dean",
    dateOfBirth: "02/18/1991",
    medicalRecordNumber: null,
    accountNumber: "88991122",
    phone: "303-555-0123",
    ssn: "900-33-1851",
    address: "261 Spruce Way, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 23,
    lastName: "Garcia",
    firstName: "Kevin",
    middleName: null,
    dateOfBirth: "12/03/1980",
    medicalRecordNumber: "2233445",
    accountNumber: null,
    phone: "303-555-0124",
    ssn: "900-34-1888",
    address: "268 Maple St, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 24,
    lastName: "Martinez",
    firstName: "Brian",
    middleName: "Scott",
    dateOfBirth: "06/25/1976",
    medicalRecordNumber: "3344557",
    accountNumber: "99112233",
    phone: "303-555-0125",
    ssn: "900-35-1925",
    address: "275 Oak Ave, Denver, CO",
    facility: "Main Campus",
    application: "Centricity with ROI",
  },
  {
    id: 25,
    lastName: "Robinson",
    firstName: "Edward",
    middleName: null,
    dateOfBirth: "04/14/1967",
    medicalRecordNumber: "4455668",
    accountNumber: null,
    phone: "303-555-0126",
    ssn: "900-36-1962",
    address: "282 Pine Rd, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 26,
    lastName: "Walker",
    firstName: "Jason",
    middleName: "Ray",
    dateOfBirth: "10/29/1983",
    medicalRecordNumber: "5566779",
    accountNumber: "11224466",
    phone: "303-555-0127",
    ssn: "900-37-1999",
    address: "289 Cedar Ln, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 27,
    lastName: "Hall",
    firstName: "Aaron",
    middleName: null,
    dateOfBirth: "08/11/1973",
    medicalRecordNumber: null,
    accountNumber: "22335577",
    phone: "303-555-0128",
    ssn: "900-38-2036",
    address: "296 Elm Dr, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 28,
    lastName: "Allen",
    firstName: "Justin",
    middleName: "Michael",
    dateOfBirth: "03/08/1988",
    medicalRecordNumber: "6677001",
    accountNumber: null,
    phone: "303-555-0129",
    ssn: "900-39-2073",
    address: "303 Birch Ct, Denver, CO",
    facility: "East Emergency",
    application: "Centricity with ROI",
  },
  {
    id: 29,
    lastName: "Young",
    firstName: "Brandon",
    middleName: null,
    dateOfBirth: "07/19/1992",
    medicalRecordNumber: "7788112",
    accountNumber: "33446688",
    phone: "303-555-0130",
    ssn: "900-40-2110",
    address: "310 Walnut Blvd, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 30,
    lastName: "King",
    firstName: "Adam",
    middleName: "Lee",
    dateOfBirth: "01/07/1975",
    medicalRecordNumber: "8899223",
    accountNumber: null,
    phone: "303-555-0131",
    ssn: "900-41-2147",
    address: "317 Spruce Way, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 31,
    lastName: "Wright",
    firstName: "Eric",
    middleName: null,
    dateOfBirth: "09/03/1981",
    medicalRecordNumber: "9900334",
    accountNumber: "44557799",
    phone: "303-555-0132",
    ssn: "900-42-2184",
    address: "324 Maple St, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 32,
    lastName: "Scott",
    firstName: "Patrick",
    middleName: "Allen",
    dateOfBirth: "11/21/1964",
    medicalRecordNumber: "1011223",
    accountNumber: null,
    phone: "303-555-0133",
    ssn: "900-43-2221",
    address: "331 Oak Ave, Denver, CO",
    facility: "East Emergency",
    application: "Centricity with ROI",
  },
  {
    id: 33,
    lastName: "Green",
    firstName: "Sean",
    middleName: null,
    dateOfBirth: "05/30/1987",
    medicalRecordNumber: null,
    accountNumber: "55668800",
    phone: "303-555-0134",
    ssn: "900-44-2258",
    address: "338 Pine Rd, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
  {
    id: 34,
    lastName: "Baker",
    firstName: "Shawn",
    middleName: "James",
    dateOfBirth: "02/12/1970",
    medicalRecordNumber: "2233446",
    accountNumber: null,
    phone: "303-555-0135",
    ssn: "900-45-2295",
    address: "345 Cedar Ln, Denver, CO",
    facility: "East Emergency",
    application: "Allscripts EHR",
  },
  {
    id: 35,
    lastName: "Nelson",
    firstName: "Ryan",
    middleName: null,
    dateOfBirth: "06/06/1989",
    medicalRecordNumber: "3344558",
    accountNumber: "66779911",
    phone: "303-555-0136",
    ssn: "900-46-2332",
    address: "352 Elm Dr, Denver, CO",
    facility: "Main Campus",
    application: "Allscripts PM",
  },
];
